import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableTeamMemberDetail = Loadable({
  loader: function loader() {
    return import('../Team/TeamMemberDetail.jsx');
  },
  loading: ComponentLoading
});
export default LoadableTeamMemberDetail;